<template>
    <div class="second-rule-box">
        <div class="second-rule-header">
            <div class="second-rule-header-text">{{ data.name || '' }}</div>
            <div class="action-button">
                <!-- <ActionButton :on-click="handleActionButtonClick" /> -->
            </div>
        </div>
        <div class="second-rule-content">
            <div class="video-box">
                <AliPlayerVOD v-if="videoId !== ''" ref="alipayvodEl" :url="videoId"></AliPlayerVOD>
            </div>
            <div class="divider"></div>
            <div class="score-box">
                <div class="score-content">
                    <div>
                        <span class="big-score">{{ data.score || 0 }}</span><span class="small-score">/{{ data.maxScore
                            || 0 }}</span>
                    </div>
                    <div class="score-text">总评分</div>
                </div>
            </div>
            <div class="divider"></div>
            <div class="text-box">
                {{ data.remark }}
            </div>
        </div>
    </div>
</template>
<script>
import ActionButton from './ActionButton.vue';
import AliPlayerVOD from '../comp/AliplayerVOD.vue'
export default {
    name: 'SecondRule',
    components: {
        // ActionButton,
        AliPlayerVOD,
    },
    props: {
        data: {
            type: Object,
            default: null
        },
        videoId: {
            type: String,
            default: null
        }
    },
    methods: {
        handleActionButtonClick(type) {
            console.log(`在SecondRule中点击了${type}按钮`);
            // 这里可以添加具体的业务逻辑处理
        }
    }
}
</script>
<style lang="less" scoped>
.second-rule-box {
    width: 100%;
    display: flex;
    flex-direction: column;
    background: rgba(0, 28, 53, 0.7);
    box-sizing: border-box;
    border: 1px solid;
    margin-bottom: 20px;
    border-image: linear-gradient(0deg, rgba(5, 133, 247, 0.3) 0%, rgba(5, 133, 247, 0.2) 50%, rgba(5, 133, 247, 0.2) 100%) 1;

    .second-rule-header {
        height: 40px;
        width: 100%;
        background: linear-gradient(90deg, rgba(13, 80, 146, 0.5) 0%, rgba(13, 80, 146, 0.5) 100%);
        position: relative;

        .second-rule-header-text {
            color: #ffffff;
            font-size: 20px;
            text-align: center;
            line-height: 40px;
            /* 与header高度一致，确保垂直居中 */
            background: url(../.././../assets/image/rule-name-bg.png) no-repeat;
            width: 420px;
            position: relative;
            left: 50%;
            transform: translateX(-50%);
            z-index: 1;
            /* 确保标题在按钮上方 */
        }

        .action-button {
            position: absolute;
            right: 10px;
            /* 调整右侧间距 */
            top: 50%;
            transform: translateY(-50%);
            /* 垂直居中 */
            display: flex;
            align-items: center;
        }
    }

    .second-rule-content {
        display: flex;
        flex-direction: row;
        height: 280px;
        padding: 20px;


        .divider {
            width: 1px;
            height: 100%;
            background: #043B6A;
            margin: 0 20px;
        }

        .video-box {
            width: 480px;
            height: 100%;
            background-color: black;
            overflow: hidden;
        }

        .score-box {
            width: 135px;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;

            .score-content {
                display: flex;
                align-items: center;
                background: url(../../../assets/image/score-bg2.png) no-repeat;
                width: 133px;
                height: 140px;
                flex-direction: column;
                gap: 10px;
                box-sizing: border-box;
                padding-top: 22px;
            }

            .big-score {
                color: #00FFC6;
                font-size: 28px;
                font-weight: 600;
            }

            .small-score {
                color: #fff;
                font-size: 16px;
                font-weight: 600;
            }

            .score-text {
                color: #fff;
                font-size: 14px;
            }
        }

        .text-box {
            height: 100%;
            color: #fff;
            font-size: 18px;
            line-height: 34px;
            font-weight: 400;
            flex: 1;
            overflow-y: auto;
            overflow-x: hidden;
            box-sizing: border-box;

            /* 自定义滚动条样式 */
            &::-webkit-scrollbar {
                width: 8px;
            }

            &::-webkit-scrollbar-track {
                background: rgba(0, 28, 53, 0.1);
                border-radius: 4px;
            }

            &::-webkit-scrollbar-thumb {
                background: rgba(5, 133, 247, 0.5);
                border-radius: 4px;
            }

            &::-webkit-scrollbar-thumb:hover {
                background: rgba(5, 133, 247, 0.8);
            }
        }
    }
}
</style>